var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is-small"},[_c('div',{staticClass:"container"},[_c('EditArticle')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }